/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".editingInput_4197d077{border:0;outline:0;width:100%}.editingInput_4197d077::-ms-clear{display:none}.editingContainer_4197d077{margin:4px}"}]);
export const editingInput = "editingInput_4197d077";
export const editingContainer = "editingContainer_4197d077";